import { Component } from '@angular/core';

@Component({
  selector: 'soq-page-content',
  templateUrl: './page-content.component.html',
  styleUrls: ['./page-content.component.scss'],
  standalone: true,
})
export class PageContentComponent {}
